import React from "react";

import CodeMirror from "@uiw/react-codemirror";

function ManuscriptTextEditorHost({
    editorRef,
    editorContent,
    extensions,
    basicSetup,
    selection,
    onOpenReviewContextMenu,
    onEditorChange,
    onUpdate,
}) {
    const getCurrentSelection = () => {
        const mainSelection = editorRef?.current?.view?.state?.selection?.main;
        if (!mainSelection) {
            return selection;
        }

        const from = Math.min(mainSelection.anchor, mainSelection.head);
        const to = Math.max(mainSelection.anchor, mainSelection.head);

        return {
            ...selection,
            from,
            to,
            hasSelection: from !== to,
        };
    };

    const openReviewContextMenu = (position) => {
        if (!getCurrentSelection()?.hasSelection) return;
        onOpenReviewContextMenu?.(position);
    };

    return (
        <div
            style={{ height: "100%" }}
            onContextMenu={(event) => {
                const editorElement = event.target.closest?.(".cm-editor");
                if (!editorElement) return;
                event.preventDefault();
                openReviewContextMenu({
                    top: event.clientY,
                    left: event.clientX,
                });
            }}
            onKeyDown={(event) => {
                const isContextMenuKey = event.key === "ContextMenu" || (event.key === "F10" && event.shiftKey);

                if (!isContextMenuKey) return;

                const editorElement = event.target.closest?.(".cm-editor");
                if (!editorElement) return;

                event.preventDefault();
                const rect = editorElement.getBoundingClientRect();
                openReviewContextMenu({
                    top: rect.top + Math.min(48, rect.height / 2),
                    left: rect.left + Math.min(48, rect.width / 2),
                });
            }}
        >
            <CodeMirror
                ref={editorRef}
                className="manuscript-codemirror"
                style={{ height: "100%" }}
                value={editorContent}
                height="100%"
                extensions={extensions}
                basicSetup={basicSetup}
                onUpdate={onUpdate}
                onChange={(value, viewUpdate) => {
                    onEditorChange(value, viewUpdate.state.selection.main.head);
                }}
            />
        </div>
    );
}

export default ManuscriptTextEditorHost;
